import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { BOOK, PRAISE } from "@/lib/site";

export default function Author() {
  return (
    <section id="author" className="relative z-10 py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-2 lg:gap-24">
        {/* Author bio */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-body text-sm uppercase tracking-[0.25em] text-gold">The Author</p>
          <h2 className="mt-3 font-display text-4xl font-bold text-cream md:text-5xl">Shaunta Scott</h2>
          <div className="mt-8 flex flex-col gap-8 sm:flex-row sm:items-start">
            <img
              src="/book/author.jpg"
              alt="Shaunta Scott, author of Hannah's Heart Awakens"
              data-testid="author-photo"
              className="h-44 w-40 flex-shrink-0 rounded-2xl border border-gold/30 object-cover object-top shadow-[0_20px_50px_-15px_rgba(0,0,0,0.7)]"
            />
            <div className="space-y-5 font-body text-lg leading-relaxed text-slate-300">
            <p>
              Shaunta Scott writes stories that help children meet the love of Jesus in gentle,
              everyday moments. <em className="text-cream not-italic font-medium">Hannah&apos;s Heart Awakens</em> is
              the heartfelt beginning of the Hannah Series — written for every child with a curious heart.
            </p>
            <p>
              Dedicated to families, educators, and mentors who long to plant seeds of faith, her
              writing is warm, honest, and full of wonder.
            </p>
            </div>
          </div>
          <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 font-body text-sm text-slate-400">
            <span><span className="text-gold">Illustrated by</span> {BOOK.illustrator}</span>
            <span><span className="text-gold">Published by</span> {BOOK.publisher}</span>
          </div>
        </motion.div>

        {/* Praise cards */}
        <div className="space-y-5">
          {PRAISE.map((p, i) => (
            <motion.blockquote
              key={p.name}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`praise-card-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur-sm transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-gold/40"
            >
              <Quote className="h-6 w-6 text-gold/70" />
              <p className="mt-4 font-display text-lg italic leading-relaxed text-cream">&ldquo;{p.quote}&rdquo;</p>
              <footer className="mt-5 font-body text-sm">
                <span className="font-semibold text-gold">{p.name}</span>
                <span className="text-slate-400"> · {p.role}</span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
